export default "__VITE_ASSET__CRdfzy1E__"